"use strict";

import Connection from "vwa/wsi/Connection";

export default new Connection();


// WEBPACK FOOTER //
// ./src/wsi.js